import { IPreviewSurveyState } from 'types/previewCampaign';
import { ICampaignQuestionDetail } from 'types/campaign';
import { QuestionType } from 'pages/admin/campaign-overview/constants';

export const closeSurvey = (
    campaignId: number,
    me: IPreviewSurveyState['me']
) => {
    window.parent.postMessage(
        { type: 'CHANGE_MODE', payload: { mode: 'pc' } },
        window.location.origin
    );
    let urlToBack = '';
    if (me.creator) {
        urlToBack = `/admin/campaign/design/${campaignId}`;
    } else if (me.type === 'Admin') {
        urlToBack = `/admin/dashboard`;
    } else {
        // close the window
    }
    window.parent.postMessage(
        {
            type: 'BACK_MODE',
            payload: { mode: urlToBack },
        },
        window.location.origin
    );
};

export const sortMatrixComponent = (
    rows: string[],
    columns: string[],
    order_by: string
) => {
    let rowsTitle = [...rows];
    const columnsTitle = [...columns];
    if (order_by === 'AZ') {
        rowsTitle = rowsTitle.sort((a, b) => a.localeCompare(b));
        // columnsTitle = columnsTitle.sort((a, b) => a.localeCompare(b));
    } else if (order_by === 'ZA') {
        rowsTitle = rowsTitle.sort((a, b) => b.localeCompare(a));
        // columnsTitle = columnsTitle.sort((a, b) => b.localeCompare(a));
    } else if (order_by === 'random') {
        rowsTitle = rowsTitle.sort(() => Math.random() - 0.5);
        // columnsTitle = columnsTitle.sort(() => Math.random() - 0.5);
    }
    return { rowsTitle, columnsTitle };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortByField = (array: any[], orderBy: string, field: string) => {
    if (orderBy === 'AZ') {
        return array.sort((a, b) => a[field].localeCompare(b[field]));
    } else if (orderBy === 'ZA') {
        return array.sort((a, b) => b[field].localeCompare(a[field]));
    } else if (orderBy === 'random') {
        return array.sort(() => Math.random() - 0.5);
    }
    return array;
};

export const previewQuestionFormatter = (
    questionRes: ICampaignQuestionDetail
) => {
    const {
        id,
        title,
        kind,
        answer_options,
        min_choice,
        max_choice,
        order_by,
        // min_score,
        max_score,
        matrix_answer_type,
        // number_of_stars,
        slider_max,
        // slider_min,
        slider_step,
        number_emoji,
        // limit_size,
        // limit_character,
        table_question_component,
        required,
        number: questionNumber,
        score_step,
        skip_logic,
        creening_logic,
        question_title_logic,
        answer_from_other_question_logic,
        branch_logic,
    } = questionRes.attributes;
    const defaultData: {
        id: number | string | null;
        question: string;
        type: string;
        answers:
            | {
                  id: number | string | null;
                  label: string;
                  image?: string;
              }[]
            | string[]
            | object;
        logics: object;
        defaultStar?: number;
        numberOfEmojis?: number;
        step?: number;
        scale?: number;
        required?: boolean;
        questionTitleLogic?: object;
        skipLogic?: object;
        questionNumber?: number;
        answerFromOtherQuestionLogic?: object;
        creeningLogic?: object[];
        branchLogic?: object[];
    } = {
        id,
        question: title,
        type: kind,
        answers: [],
        logics: {},
        required,
        questionTitleLogic: question_title_logic,
        skipLogic: skip_logic,
        questionNumber,
        answerFromOtherQuestionLogic: answer_from_other_question_logic,
        creeningLogic: creening_logic,
        branchLogic: branch_logic,
    };
    switch (kind) {
        case QuestionType.Checkbox:
        case QuestionType.SingleChoice: {
            let normalAnswers = answer_options.filter(
                (option) => option.ordinal === 0
            );
            const otherAnswers = answer_options.filter(
                (option) => option.ordinal !== 0
            );
            normalAnswers = sortByField(normalAnswers, order_by, 'text');
            const listAnswers = normalAnswers.concat(otherAnswers);
            defaultData.answers = listAnswers.map((option) => ({
                id: option.id,
                label: option.text,
                image: option.image,
                type: option.ordinal,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            if (kind === QuestionType.Checkbox) {
                defaultData.logics = {
                    orderBy: order_by,
                    minChoice: min_choice,
                    maxChoice: max_choice,
                };
            }
            break;
        }
        case QuestionType.ScoreStarFull: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.defaultStar = 5;
            break;
        }
        case QuestionType.ScoreStarHalf: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.defaultStar = 5;
            break;
        }
        case QuestionType.Score: {
            defaultData.answers = {
                scale: max_score,
                step: score_step,
            };
            break;
        }
        case QuestionType.Dropdown: {
            let sortAnswers = answer_options;
            sortAnswers = sortByField(sortAnswers, order_by, 'text');
            defaultData.answers = sortAnswers.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            break;
        }
        case QuestionType.Image: {
            break;
        }
        case QuestionType.ImageWithTitle: {
            defaultData.answers = {
                images: answer_options.map((option) => {
                    return {
                        label: option.text,
                        value: option.id,
                    };
                }),
            };
            break;
        }
        case QuestionType.Emoji: {
            defaultData.numberOfEmojis = number_emoji;
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.TextboxRecommend: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.TextboxRecommendMultiChoice: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.Rank: {
            let sortAnswers = answer_options;
            sortAnswers = sortByField(sortAnswers, order_by, 'text');
            defaultData.answers = sortAnswers.map((option, index) => ({
                id: option.id,
                label: option.text,
                position: index + 1,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            break;
        }
        case QuestionType.SliderScale: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.step = slider_step;
            defaultData.scale = slider_max;
            break;
        }
        case QuestionType.MatrixText: {
            defaultData.answers = {
                rowsTitle: table_question_component.rows,
                columnsTitle: table_question_component.columns,
                matrix: table_question_component.rows.map(() =>
                    table_question_component.columns.map(() => '')
                ),
            };
            break;
        }
        case QuestionType.MatrixCheckbox: {
            const { rowsTitle, columnsTitle } = sortMatrixComponent(
                table_question_component.rows,
                table_question_component.columns,
                order_by
            );
            defaultData.answers = {
                rowsTitle: rowsTitle,
                columnsTitle: columnsTitle,
                matrix:
                    matrix_answer_type === 'row'
                        ? rowsTitle.map(() => columnsTitle.map(() => false))
                        : columnsTitle.map(() => rowsTitle.map(() => false)),
            };
            defaultData.logics = {
                orderBy: order_by,
                matrixAnswerType: matrix_answer_type,
                minChoice: min_choice,
                maxChoice: max_choice,
            };
            break;
        }
        case QuestionType.MatrixRadio: {
            const { rowsTitle, columnsTitle } = sortMatrixComponent(
                table_question_component.rows,
                table_question_component.columns,
                order_by
            );
            defaultData.answers = {
                rowsTitle: rowsTitle,
                columnsTitle: columnsTitle,
                matrix:
                    matrix_answer_type === 'row'
                        ? rowsTitle.map(() => '')
                        : columnsTitle.map(() => ''),
            };
            defaultData.logics = {
                orderBy: order_by,
                matrixAnswerType: matrix_answer_type,
            };
            break;
        }
        case QuestionType.Date: {
            defaultData.answers = {
                day: '',
                month: '',
                year: '',
            };
            break;
        }
        default:
    }
    return defaultData;
};

export const previewLogicPageQuestionFormatter = (
    questionRes: ICampaignQuestionDetail
) => {
    const {
        id,
        title,
        kind,
        answer_options,
        min_choice,
        max_choice,
        order_by,
        // min_score,
        max_score,
        matrix_answer_type,
        // number_of_stars,
        slider_max,
        // slider_min,
        slider_step,
        number_emoji,
        // limit_size,
        // limit_character,
        table_question_component,
        required,
        number: questionNumber,
        score_step,
        skip_logic,
        creening_logic,
        question_title_logic,
        answer_from_other_question_logic,
        branch_logic,
        is_page_config,
    } = questionRes.attributes;
    const defaultData: {
        id: number | string | null;
        question: string;
        type: string;
        answers:
            | {
                  id: number | string | null;
                  label: string;
                  image?: string;
              }[]
            | string[]
            | object;
        logics: object;
        defaultStar?: number;
        numberOfEmojis?: number;
        step?: number;
        scale?: number;
        required?: boolean;
        questionTitleLogic?: object;
        skipLogic?: object;
        questionNumber?: number;
        answerFromOtherQuestionLogic?: object;
        creeningLogic?: object[];
        branchLogic?: object[];
        isPageConfig?: boolean;
    } = {
        id,
        question: title,
        type: kind,
        answers: [],
        logics: {},
        required,
        questionTitleLogic: question_title_logic,
        skipLogic: skip_logic,
        questionNumber,
        answerFromOtherQuestionLogic: answer_from_other_question_logic,
        creeningLogic: creening_logic,
        branchLogic: branch_logic,
        isPageConfig: is_page_config,
    };
    switch (kind) {
        case QuestionType.Checkbox:
        case QuestionType.SingleChoice: {
            let normalAnswers = answer_options.filter(
                (option) => option.ordinal === 0
            );
            const otherAnswers = answer_options.filter(
                (option) => option.ordinal !== 0
            );
            normalAnswers = sortByField(normalAnswers, order_by, 'text');
            const listAnswers = normalAnswers.concat(otherAnswers);
            defaultData.answers = listAnswers.map((option) => ({
                id: option.id,
                label: option.text,
                image: option.image,
                type: option.ordinal,
                question_page_id: option.question_page_id,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            if (kind === QuestionType.Checkbox) {
                defaultData.logics = {
                    orderBy: order_by,
                    minChoice: min_choice,
                    maxChoice: max_choice,
                };
            }
            break;
        }
        case QuestionType.ScoreStarFull: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.defaultStar = 5;
            break;
        }
        case QuestionType.ScoreStarHalf: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.defaultStar = 5;
            break;
        }
        case QuestionType.Score: {
            defaultData.answers = {
                scale: max_score,
                step: score_step,
            };
            break;
        }
        case QuestionType.Dropdown: {
            let sortAnswers = answer_options;
            sortAnswers = sortByField(sortAnswers, order_by, 'text');
            defaultData.answers = sortAnswers.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            break;
        }
        case QuestionType.Image: {
            break;
        }
        case QuestionType.ImageWithTitle: {
            defaultData.answers = {
                images: answer_options.map((option) => {
                    return {
                        label: option.text,
                        value: option.id,
                    };
                }),
            };
            break;
        }
        case QuestionType.Emoji: {
            defaultData.numberOfEmojis = number_emoji;
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.TextboxRecommend: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.TextboxRecommendMultiChoice: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            break;
        }
        case QuestionType.Rank: {
            let sortAnswers = answer_options;
            sortAnswers = sortByField(sortAnswers, order_by, 'text');
            defaultData.answers = sortAnswers.map((option, index) => ({
                id: option.id,
                label: option.text,
                position: index + 1,
            }));
            defaultData.logics = {
                orderBy: order_by,
            };
            break;
        }
        case QuestionType.SliderScale: {
            defaultData.answers = answer_options.map((option) => ({
                id: option.id,
                label: option.text,
            }));
            defaultData.step = slider_step;
            defaultData.scale = slider_max;
            break;
        }
        case QuestionType.MatrixText: {
            defaultData.answers = {
                rowsTitle: table_question_component.rows,
                columnsTitle: table_question_component.columns,
                matrix: table_question_component.rows.map(() =>
                    table_question_component.columns.map(() => '')
                ),
            };
            break;
        }
        case QuestionType.MatrixCheckbox: {
            const { rowsTitle, columnsTitle } = sortMatrixComponent(
                table_question_component.rows,
                table_question_component.columns,
                order_by
            );
            defaultData.answers = {
                rowsTitle: rowsTitle,
                columnsTitle: columnsTitle,
                matrix:
                    matrix_answer_type === 'row'
                        ? rowsTitle.map(() => columnsTitle.map(() => false))
                        : columnsTitle.map(() => rowsTitle.map(() => false)),
            };
            defaultData.logics = {
                orderBy: order_by,
                matrixAnswerType: matrix_answer_type,
                minChoice: min_choice,
                maxChoice: max_choice,
            };
            break;
        }
        case QuestionType.MatrixRadio: {
            const { rowsTitle, columnsTitle } = sortMatrixComponent(
                table_question_component.rows,
                table_question_component.columns,
                order_by
            );
            defaultData.answers = {
                rowsTitle: rowsTitle,
                columnsTitle: columnsTitle,
                matrix:
                    matrix_answer_type === 'row'
                        ? rowsTitle.map(() => '')
                        : columnsTitle.map(() => ''),
            };
            defaultData.logics = {
                orderBy: order_by,
                matrixAnswerType: matrix_answer_type,
            };
            break;
        }
        case QuestionType.Date: {
            defaultData.answers = {
                day: '',
                month: '',
                year: '',
            };
            break;
        }
        default:
    }
    return defaultData;
};
